import { Redirect } from '#app/components/Redirect/index.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { appendSearch } from '#app/utilities/appendSearch.js';
import { getRoute } from '@contra/routes';
import { parse } from '@contra/utilities/queryString';

export const Page = () => {
  const { search } = useLocation();
  return (
    <Redirect
      method="replace"
      to={appendSearch(
        getRoute('/sign-up', {
          search: {
            expedited: true,
            redirectTo: appendSearch('/independent/home', {
              ...parse(search),
              upgradeToPro: true,
            }),
            userType: 'independent',
          },
        }),
      )}
    />
  );
};
